module.exports = __webpack_public_path__ + "static/media/perfil.0fde6024.png";